// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding-top: 50px;
}

.aptsi-logo {
  max-width:50px;

}
.navbar {
  margin-bottom: 0px;
  background-color: #000000;
  padding-top: 1px;
  padding-bottom: 1px;
}
.dropdown-menu {
  min-width: 200px;
}
.dropdown-menu.columns-2 {
  min-width: 400px;
}
.dropdown-menu.columns-3 {
  min-width: 600px;
}
.dropdown-menu li a {
  padding: 5px 15px;
  font-weight: 300;
}
.multi-column-dropdown {
  list-style: none;
  margin: 0;
  padding: 0;
}
.multi-column-dropdown li a {
  display: block;
  clear: both;
  line-height: 1.428571429;
  color: #333;
  white-space: normal;
}
.multi-column-dropdown li a:hover {
  text-decoration: none;
  color: #262626;
  background-color: #f5f5f5;
}
.blue-text {
  color: rgb(139,139,255);
 }
hr.aptsiLine1 {
    display: block;
    height: 1px;
    border: 10px solid rgb(3, 3, 44);
    border-top: 0;
    margin: 1em 0;
    padding: 0;
}


@media (max-width: 767px) {
  .dropdown-menu.multi-column {
    min-width: 240px !important;
    overflow-x: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;;AAEhB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,uBAAuB;CACxB;AACD;IACI,cAAc;IACd,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb,UAAU;AACd;;;AAGA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;AACF","sourcesContent":["body {\r\n  padding-top: 50px;\r\n}\r\n\r\n.aptsi-logo {\r\n  max-width:50px;\r\n\r\n}\r\n.navbar {\r\n  margin-bottom: 0px;\r\n  background-color: #000000;\r\n  padding-top: 1px;\r\n  padding-bottom: 1px;\r\n}\r\n.dropdown-menu {\r\n  min-width: 200px;\r\n}\r\n.dropdown-menu.columns-2 {\r\n  min-width: 400px;\r\n}\r\n.dropdown-menu.columns-3 {\r\n  min-width: 600px;\r\n}\r\n.dropdown-menu li a {\r\n  padding: 5px 15px;\r\n  font-weight: 300;\r\n}\r\n.multi-column-dropdown {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.multi-column-dropdown li a {\r\n  display: block;\r\n  clear: both;\r\n  line-height: 1.428571429;\r\n  color: #333;\r\n  white-space: normal;\r\n}\r\n.multi-column-dropdown li a:hover {\r\n  text-decoration: none;\r\n  color: #262626;\r\n  background-color: #f5f5f5;\r\n}\r\n.blue-text {\r\n  color: rgb(139,139,255);\r\n }\r\nhr.aptsiLine1 {\r\n    display: block;\r\n    height: 1px;\r\n    border: 10px solid rgb(3, 3, 44);\r\n    border-top: 0;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\n\r\n@media (max-width: 767px) {\r\n  .dropdown-menu.multi-column {\r\n    min-width: 240px !important;\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
